const TILE_CONFIGS = [
  {
    label: 'offerWizard.stepWhichBusinessCustomerProduct.immoCharging',
    value: 'immoCharging',
    iconComponent: 'BusinessChargingIcon',
    urlValue: 'ImmoCharging',
  },
  {
    label: 'offerWizard.stepWhichBusinessCustomerProduct.coopCharging',
    value: 'coopCharging',
    iconComponent: 'BusinessChargingIcon',
    urlValue: 'CoopCharging',
  },
];

export default TILE_CONFIGS;
